export const getVisitorTypeSubnav = (projectId: string, visitorTypeId: string) => [
  {
    title: 'Visitor Type Details',
    to: `/project/${projectId}/visitor-type/${visitorTypeId}`
  },
  {
    title: 'Translations',
    to: `/project/${projectId}/visitor-type/${visitorTypeId}/translations`
  },
]
